#import "../LookupAccountFields.graphql"
query LookupAccountCoaSearch(
  $chartOfAccountId: UUID!
  $first: Int
  $lookupName: String!
  $orderBy: [LookupAccountsOrderBy!]
  $after: Cursor
  $filter: LookupAccountFilter
) {
  lookupAccountCoaSearch(
    chartOfAccountId: $chartOfAccountId
    first: $first
    lookupName: $lookupName
    orderBy: $orderBy
    after: $after
    filter: $filter
  ) {
    nodes {
      ...LookupAccountFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
